<template>
  <div class="input-group">
    <input :id="inputId" type="text" :class="['form-control share copy-url-field', {'form-control-lg': useLargeControls}, inputAdditionalCssClasses]"
           readonly="true" :value="urlWithShareClickToken()" @focus="trackShareFocus">
    <button ref="copyUrlButton" type="button" :data-clipboard-target="inputUrlSelector"
            :class="['btn share copy-url', {'btn-lg': useLargeControls}, buttonAdditionalCssClasses]">
      {{ copyButtonLabel }}
    </button>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import { trackShareOpen } from '../../analytics/track'
import { nextTick } from 'vue'
import {v4 as uuid} from 'uuid'
import ajax from '../../helpers/ajax'

export default {
  props: {
    buttonAdditionalCssClasses: {
      type: String,
      required: false,
      default: ''
    },
    entitySlug: {
      type: String,
      required: true
    },
    entityType: {
      type: String,
      required: true
    },
    inputAdditionalCssClasses: {
      type: String,
      required: false,
      default: ''
    },
    inputId: {
      type: String,
      default: 'url-field'
    },
    shareClicksPath: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    useLargeControls: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      copiedUrl: false,
      shareClickCreated: false,
      shareClickToken: uuid()
    }
  },

  computed: {
    copyButtonLabel() {
      if (this.copiedUrl) {
        return this.i18n.t('social.copied')
      } else {
        return this.i18n.t('public.social.share_on_rawlink')
      }
    },

    inputUrlSelector() {
      return `#${this.inputId}`
    }
  },

  mounted() {
    nextTick(() => {
      const clipboardOptions = {
        // Define a custom function for text to be copied to clipboard so we can append the share click token
        text: () => {
          this.trackShareClick()
          this.copiedUrl = true
          setTimeout(() => {
            this.copiedUrl = false
          }, 1800)

          return this.urlWithShareClickToken()
        }
      }

      // clipboard requires setting the 'container' option when it's used in a Bootstrap modal:
      // https://clipboardjs.com/#advanced-usage
      const parentModal = this.$refs.copyUrlButton.closest('.modal')
      if (parentModal) {
        clipboardOptions['container'] = parentModal
      }

      new ClipboardJS('button.copy-url', clipboardOptions)
    })
  },

  methods: {
    trackShareFocus() {
      this.trackShareClick()
    },

    trackShareClick() {
      if (!this.shareClickCreated) {
        ajax.post({
          url: this.shareClicksPath,
          data: {
            token: this.shareClickToken,
            medium: 'rawlink'
          },
          successHandler: () => {
            trackShareOpen('rawlink', this.entityType, this.entitySlug)
            this.shareClickCreated = true
          }
        })
      }
    },

    urlWithShareClickToken() {
      const urlObj = new URL(this.url)
      urlObj.searchParams.append('share', this.shareClickToken)

      return urlObj.toString()
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "~common_styles/breakpoints" as breakpoints;

  .copy-url-field {
    color: #999999;
    border-color: #e2e2e2;
  }

  .copy-url {
    // Set fixed width to avoid button changing size when switching label after copying
    width: 150px;

    text-transform: unset;
    padding: 1rem;
    font-size: 1rem;

    &.btn-lg {
      @include breakpoints.screen-md-up {
        width: 200px;
      }
    }
  }
</style>
